import axios from 'axios'
import common from "@/util/common";
import Nprogress from 'nprogress'
// 导入进度条样式

// API配置文件
// const defaultRequestUrl = 'http://cloudapi.tdin360.com/land' 						// 测试服务器请求地址
// const defaultRequestUrl = 'https://192.168.0.151:9030/land'
const defaultRequestUrl = 'https://childapi.gzsnjzx.com/land'
//https://api.grounds.gzrrtc.com/

// 代理跨域配置
// axios.create({
//     baseURL:'/api',
//     timeout:5000,
//     withCredentials: false
// })

// 默认请求地址
axios.defaults.baseURL = defaultRequestUrl

// 拦截请求
axios.interceptors.request.use(config => {
    // Nprogress.start()
    return config
},(error => {Promise.reject(error)}))

// 拦截响应 // 相应结束的时候隐藏进度条
axios.interceptors.response.use(config => {
    // Nprogress.done()
    //必须返回config
    return config
},(error => {Promise.reject(error)}))


const ServerUrl = {
    ServerApi: defaultRequestUrl,									    // 服务拼接地址
    BannerList: '/api/bannerList',                              // 轮播图
    AategorList: '/api/categories',                             // 获取项目分类列表
    newList: '/api/projectNewList',                             // 获取最新项目列表（首页全部分类）
    listByCategory: '/api/projectsByCategoryId',                // 更具分类获取项目列表
    getDetail: '/api/projectDetailById',                            // 项目详情
    search:'/api/findByKeyWord',                                // 搜索
    vrview:'/vr/show?url=',                                          // 全景图
}

function http(options) {
    var el = document.getElementsByTagName('body')[0]; // H5屏蔽
    // el.classList.add("show_mask"); // 禁用点击

    return new Promise((resolv, reject) => {
        axios({
            method: options.method || 'get',
            url: options.url,
            data: options.data || {},
            params:options.params || {},
            headers:options.headers || {},
            timeout: 5000,
        }).then((res)=>{
            el.classList.remove("show_mask"); // 解除
            if(res !== undefined){
                if(res.data.data !== null ){
                    if(JSON.stringify(res.data.data)[0] === '{' &&  JSON.stringify(res.data.data)[JSON.stringify(res.data.data).length-1] ==='}'){
                        var linsData = []
                        linsData.push(res.data.data)
                        res.data.data = common.DataCheck(linsData) // 处理源数据
                    }else{
                        res.data.data = common.DataCheck(res.data.data) // 处理源数据
                    }
                }
                console.log('源',res)
                resolv(res.data)
            }

        }).catch((err)=>{
            console.log('源',err)
            el.classList.remove("show_mask"); // 解除
            reject(err)
        });
    })
}
export default {
    ServerUrl,
    http
}
